import { cn } from "@/lib/cn";
import { Button } from "@/components/ui";
import { Icons } from "@/components/ui/icons";

interface OAuthPromptCardProps {
  appName: string;
  appInitial: string;
  agentName: string;
  reason: string;
  onConnect?: () => void;
  onDismiss?: () => void;
  className?: string;
}

export function OAuthPromptCard({
  appName,
  appInitial,
  agentName,
  reason,
  onConnect,
  onDismiss,
  className,
}: OAuthPromptCardProps) {
  return (
    <div
      className={cn(
        "w-72 rounded-xl border border-glass-stroke bg-glass-fill backdrop-blur-md shadow-lg p-4 flex flex-col gap-3",
        className,
      )}
      data-testid="oauth-prompt-card"
    >
      {/* App + agent row */}
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-glass-fill border border-glass-stroke text-canvas-md font-bold text-primary shrink-0">
          {appInitial}
        </div>
        <div>
          <p className="text-canvas-base text-muted">{agentName} needs access to</p>
          <p className="text-canvas-md font-semibold text-primary">{appName}</p>
        </div>
      </div>

      {/* Reason */}
      <p className="text-canvas-base text-secondary leading-relaxed">{reason}</p>

      {/* Actions */}
      <div className="flex gap-2">
        <Button
          className={cn(
            "flex-1 text-black hover:opacity-90 hover:brightness-100",
          )}
          style={{ backgroundColor: "var(--color-accent)" }}
          onClick={onConnect}
          data-testid="oauth-prompt-connect-btn"
        >
          <Icons.Link className="h-3 w-3" />
          Connect {appName}
        </Button>
        <Button
          variant="secondary"
          onClick={onDismiss}
          data-testid="oauth-prompt-dismiss-btn"
        >
          Later
        </Button>
      </div>
    </div>
  );
}
